import { clearInvoiceTrackingContext } from "./tracking";
import { clearInvoiceGamePlatform, setInvoiceGamePlatform } from "@/apis/invoiceCenterPlatform";

let invoiceSession = "";

export const consumeInvoiceSession = route => {
  const routeSession = route.query.invoice_session;
  const routePlatform = route.query.game_platform;
  if (routeSession) {
    invoiceSession = routeSession;
    setInvoiceGamePlatform(routePlatform);
  } else if (routePlatform) {
    setInvoiceGamePlatform(routePlatform);
  }
  if (routeSession || routePlatform) {
    const query = { ...route.query };
    delete query.invoice_session;
    delete query.game_platform;
    window.history.replaceState(null, "", route.path + buildQuery(query));
  }
  return invoiceSession;
};
export const getInvoiceSession = () => invoiceSession;

export const clearInvoiceSession = () => {
  invoiceSession = "";
  clearInvoiceGamePlatform();
  clearInvoiceTrackingContext();
};
const buildQuery = query => {
  const values = Object.keys(query || {}).reduce((items, key) => {
    const value = query[key];
    if (value === undefined || value === null || value === "") return items;
    items.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return items;
  }, []);
  return values.length ? "?" + values.join("&") : "";
};
